<template>
  <div :class="{ fed: isFixed,'body-left':true}" ref="leftDiv">
    <!--        <div>-->
    <!--            <span>真题模拟</span>-->
    <!--            <el-divider direction="vertical"></el-divider>-->
    <!--            <span>专项训练</span>-->
    <!--        </div>-->
    <el-col>
      <el-menu :default-active="activeIndex" class="el-menu-vertical-demo">
        <el-menu-item index="0" class="all-item" @click="selectMatchAndLang('ALL',0,'ALL',0)">
          <i class="el-icon-menu"></i>
          <span slot="title">全部</span>
        </el-menu-item>
        <el-menu-item index="1" @click="selectMatchAndLang('QCEIT',1,'ALL',0)">
          <span slot="title">中国电子学会</span>
        </el-menu-item>
        <el-menu-item index="2" @click="selectMatchAndLang('CCF_GESP',2,'ALL',0)">
          <span slot="title">GESP CCF编程能力等级认证</span>
        </el-menu-item>
        <el-menu-item index="3" @click="selectMatchAndLang('NOI',3,'ALL',0)">
          <span slot="title">全国中学生信息学奥林匹克竞赛</span>
        </el-menu-item>
        <el-menu-item index="4" @click="selectMatchAndLang('LANQIAO',4,'LANQIAO_ALL',0)">
          <span slot="title">蓝桥杯</span>
        </el-menu-item>
        <el-menu-item index="5" @click="selectMatchAndLang('XXSY',5,'XXSY_ALL',0)">
          <span slot="title">全国信息青少年素养大赛</span>
        </el-menu-item>
        <el-menu-item index="6" @click="selectMatchAndLang('NOC',6,'NOC_ALL',0)">
          <span slot="title">全国中小学信息技术创新与实践大赛</span>
        </el-menu-item>

        <!--                <el-menu-item index="7" @click="selectMatchAndLang('SYSW',6,'SW',2)">-->
        <!--                    <span slot="title">计算思维</span>-->
        <!--                </el-menu-item>-->
        <el-menu-item index="7" @click="selectMatchAndLang('SCHOOL',7,'ALL',0)">
          <span slot="title">各校各地真题</span>
        </el-menu-item>
        <el-menu-item index="8" @click="selectMatchAndLang('CPA',8,'ALL',0)">
          <span slot="title">CPA</span>
        </el-menu-item>
        <el-menu-item index="9" @click="selectMatchAndLang('AI',9,'ALL',0)">
          <span slot="title">人工智能AI</span>
        </el-menu-item>
        <el-menu-item index="10" @click="selectMatchAndLang('OTHER',10,'ALL',0)">
          <span slot="title">其他</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </div>
</template>

<script>
export default {
  name: "leftSelect",
  props: ['leftMathIndex'],
  data() {
    return {
      activeIndex: '0',
      isFixed: false,
    }
  },
  methods: {
    selectMatchAndLang(matchName, matchIndex, langName, langIndex) {
      const data = {
        matchName: matchName,
        matchIndex: matchIndex,
        langName: langName,
        langIndex: langIndex
      };
      this.$emit('select-match-lang', data);
    },
    handleScrollx() {
      // console.log('滚动高度', window.pageYOffset);
      const juli = window.pageYOffset;
      // console.log('距离顶部高度', this.$refs.leftDiv.getBoundingClientRect().top);
      if (juli >= 20) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },
    adjustHeight() {
      this.$nextTick(() => {
        const parent = this.$el.parentElement;
        if (parent) {
          const sibling = parent.querySelector('.body-main');
          if (sibling) {
            const siblingHeight = sibling.offsetHeight;
            const viewportHeight = window.innerHeight;
            this.$refs.leftDiv.style.height = Math.min(viewportHeight, siblingHeight) + 'px';
          }
        }
      });
    },

  },
  watch: {
    leftMathIndex: {
      handler: function (n, o) {
        if (n !== undefined) {
          // if (n === 7 || n === 8 || n === 10) {
          //   n = 9
          // }
          this.activeIndex = n.toString();
        }
      }
    },
  },
  mounted() {
    // 滚动条的获取
    window.addEventListener('scroll', this.handleScrollx, true);
    // 动态调整高度
    this.adjustHeight();
    window.addEventListener('resize', this.adjustHeight);
    // 监听 DOM 变化
    this.observer = new MutationObserver(this.adjustHeight);
    const parent = this.$el.parentElement;
    if (parent) {
      this.observer.observe(parent, { childList: true, subtree: true, attributes: true });
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollx, true);
    window.removeEventListener('resize', this.adjustHeight);
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
</script>

<style lang="scss" scoped>

.body-left {
  width: 260px;
  margin-right: 15px;
  box-sizing: border-box;
  border-radius: 6px;
  background: #fff;
  overflow-x: hidden;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  position: sticky;
  top: 20px;
  align-self: flex-start;
}

/* 菜单整体样式优化 */
::v-deep .el-menu {
  border-right: none;
  padding: 8px 0;

  .el-menu-item {
    height: 48px;
    line-height: 48px;
    margin: 2px 8px;
    border-radius: 6px;
    padding: 0 16px !important;
    font-size: 14px;
    color: #333;
    transition: all 0.2s ease;

    i {
      margin-right: 8px;
      color: #0080FF;
    }

    &:hover {
      background: #E7F3FF;
      color: #0080FF;
    }

    &.is-active {
      background: #409EFF !important;
      color: #fff !important;

      i {
        color: #fff;
      }
    }

    &.all-item.is-active {
      background: transparent !important;
      color: #0080FF !important;

      i {
        color: #0080FF;
      }
    }

    &:focus {
      background: transparent;

      &.is-active {
        background: #409EFF !important;
      }
    }
  }
}

</style>
